import { NextUIProvider } from "@nextui-org/react";

import Home from "./Screens/Home";

function App() {
  return (
    <NextUIProvider className="dark">
      <Home />
    </NextUIProvider>
  );
}

export default App;
